<template>
    <div class="monitor_wrap Monitor">
        <div class="mainHead">
            <div class="route">
                <span class="crumbs"></span><span>监控中心</span>
            </div>
        </div>
        <div class="fixedScorll" :style="{height: heightCard + 'px'}">
            <div class="mains clearfix">
                <div class="main_left" :style="{width: widthNum + 'px'}">
                    <div class="maindetails">
                        <div>
                            <div class="detailsName"> 
                                <span style="padding-right: 10px">建筑名称:</span><span>{{this.BuildingDatil.buildingName}}</span>
                            </div>
                            <div class="detailsDevice">
                                <span style="padding-right: 10px">监测设备数:</span><span>{{this.deviceNum}} (启用) </span> <span style="display:inlin-block;margin:10px;">|</span><span> {{this.failCount}} (禁用)</span>
                            </div>
                        </div>
                        <div class="detailAddress">
                            <span style="padding-right: 10px">建筑地址:</span><span v-html="this.BuildingDatil.address"></span>
                        </div>
                    </div>
                    <todo-List class="aa" style="max-height:692px; overflow-y:auto;" :pageActive="pageActive" :tabArray="tabArray" :detailsArray="detailsArray" :style="{height: heightBg + 'px'}" @listenType="listenType" @listenSearch="listenSearch" @listenSeav="listenSeav"></todo-List>
                </div>
                <div class="main_right">
                        <h2>{{names}}</h2>
                        <div class="monitor">
                            <h3>实时监控<span style="font-weight: normal;" class="pull-right">总计：{{total}}台</span></h3>
                            <ul v-show="select0">
                                <li v-for="(item,index) in monitorList" :key="index">
                                    <span>{{item.name}}</span>
                                    <el-progress class="pull-left" :percentage="item.percentage" :show-text="false" :stroke-width="7"><span style="color:#282828!important;">{{item.value}}</span></el-progress>
                                    <span class="pull-right" style="color:#198cff">{{item.value}}</span>
                                </li>
                            </ul>
                            <div class="No" v-show="!select0">
                                <img src="../../../static/img/gongxi.png">
                                <span>恭喜，当前暂无报警设备！</span>
                            </div>
                        </div>
                        <div class="give_alarm">
                            <h3>实时监测报警类型</h3>
                            <div id="first" style="width: 100%;height:214px;" v-show="select1"></div>
                            <div class="No" v-show="!select1">
                                <img src="../../../static/img/gongxi.png">
                                <span>恭喜，当前暂无报警设备！</span>
                            </div>
                        </div>
                        <div class="hand_situa">
                            <h3>实时报警处理情况</h3>
                            <div id="two" style="width: 100%;height:214px;" v-show="select2"></div>
                            <div class="No" v-show="!select2">
                                <img src="../../../static/img/gongxi.png">
                                <span>恭喜，当前报警已全部处理完毕！</span>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import todoList from "@/components/todoList";
    import echarts from 'echarts';
    import {ajaxFuncJson} from '@/api/ajax';
    require('echarts/theme/macarons'); // echarts theme
    export default {
        name: 'Monitoring',
        components: {
            todoList
        },
        inject:['reload'],
        data () {
            return {
                msg: '监控中心',
                pageActive: '1',
                names: sessionStorage.getItem('Name'),
                tabArray:[], //Tab选项值
                detailsArray:[],
                heightCard: '',
                heightBg:'',
                BuildingDatil: {},
                deviceNum:'',
                failCount:'',
                btnS: true,
                parms:{
                  customerId:'',
                  buildingId:'',
                  runStatus:[],
                  connectStatus:[],
                  searchName:"",
                  deviceStatus:[],
                  type:[],
                  enabled:[]
                },
                activeName: 'second',
                widthNum: '',   //中间区域自适应宽度
                widthCard: '', //计算卡片宽度
                widthText: '', //计算卡片文本宽度
                total: 0,  //实时监控总计
                cydata:[],  //实时监测报警类型Y轴标题
                dataList:[  //实时告警处理情况数据
                    {value:0, name:'待处理'},
                    {value:0, name:'处理中'},
                    {value:0, name:'审核中'},
                ],
                searchInput:'',
                monitorList:[   //实时监控数据
                    {
                      name:'正常',
                      percentage:0,
                      value:0,
                    },
                    {
                      name:'告警',
                      percentage:0,
                      value:0,
                    },
                    {
                        name:'预警',
                        percentage:0,
                        value:0,
                    },        
                    {
                      name:'离线',
                      percentage:0,
                      value:0,
                    },
                ],
                isShowDot:false,
                select0:true,
                select1: true,
                select2: true,
                windowResize:null,
            }
        },
        created() {
            this.detailsArray = false;
            this.getMonitor();
            this.getAlarmNotice();
            this.getTabListAtax();//获取TAB设备类型
            if(sessionStorage.getItem('ruleFormOption') && sessionStorage.getItem('returnType') == '1'){
              let ruleFormOption = JSON.parse(sessionStorage.getItem('ruleFormOption'));
              if(ruleFormOption){
                this.parms.deviceStatus = ruleFormOption.deviceStatusVal; //赋值Type选择值
                this.parms.runStatus = ruleFormOption.monitorStateVal; //赋值Type选择值
                this.parms.connectStatus = ruleFormOption.communicationStateVal; //赋值Type选择值
                this.parms.enabled = ruleFormOption.pointStateVal; //赋值Type选择值
                // this.getDetailsList();
              }
            }else{
                // this.getDetailsList(); //获取详情信息
                }
        },
        computed:{
            getMap() {
                return this.$store.state.menuS
            },
            leftoggle() {
                return this.$store.state.leftoggle
            },
            navTopMsg() {
                return this.$store.state.navTopMsg
            }
        },
        watch: {
            leftoggle (newV, oldV) { // status的变化，然后执行操作
                this.initFont();
            },
            navTopMsg(val) {
                this.getMonitor();
                this.getAlarmNotice();
                if(this.isAuth('common:interface')){
                  this.getTabListAtax();//获取TAB设备类型
                }
                this.getDetailsList(); //获取详情信息
                this.names = sessionStorage.getItem('Name');
            },
            
            getMap(newV, oldV) { // status的变化，然后执行操作
                sessionStorage.setItem('tabValue',0); //重置搜索
                this.reload();
                this.parms.deviceStatus = []
                this.parms.runStatus = []
                this.parms.connectStatus = []
                this.parms.enabled = []
                
                this.names = sessionStorage.getItem('Name');
                this.initFont();
            },
        },
        methods:{
            listenType(data){ //监听子组件Tab
                if(data == '0'){
                  this.parms.type = []; //赋值Type选择值
                }else{
                  this.parms.type = data; //赋值Type选择值
                }
                this.getDetailsList();
            },
            listenSearch(data){//子:失去焦点查询
                this.parms.searchName = data; //赋值Type选择值
                this.getDetailsList();
            },
            listenSeav(data){ //监听子组件保存
                this.parms.deviceStatus = data.deviceStatusVal; //赋值Type选择值
                this.parms.runStatus = data.monitorStateVal; //赋值Type选择值
                this.parms.connectStatus = data.communicationStateVal; //赋值Type选择值
                this.parms.enabled = data.pointStateVal; //赋值Type选择值
                this.getDetailsList();
            },
            getTabListAtax(){ //获取Tab列表选项
                let parms = {
                    buildingId: sessionStorage.getItem("buildingId"),//赋值建筑id                                
                    customerId: sessionStorage.getItem("customerId"),//赋值客户id
                    target: '0',
                }          
                ajaxFuncJson('/basicData/getMonitorType',parms).then(res=>{
                    if(res.data.status == 200){
                        this.tabArray = [];//先清空
                        this.tabArray = res.data.data; //获取Tab列表选项
                        let totalNum = 0;
                        this.tabArray.forEach((a,b)=>{
                            totalNum += a.warnNum;
                        })
                        let Objective = {
                            flag: true,
                            name: "全部",
                            type: '',
                            warnNum: totalNum,
                        }
                        this.tabArray.unshift(Objective);
                this.getDetailsList(); //获取详情信息

                    }
                })
            },
            //获取详情
            getDetailsList(){
                if(this.isAuth('common:interface')) {
                    this.parms.buildingId = sessionStorage.getItem("buildingId"),//赋值建筑id      
                    this.parms.customerId = sessionStorage.getItem("customerId"),//赋值客户id   
                    this.parms.target = '0',
                    ajaxFuncJson('/basicData/getMonitorByMultipleMatching',this.parms).then(res=>{
                        if(res.data.status == 200){
                            let analysis= res.data.data;
                            if(analysis.BuildingDatil){
                                this.BuildingDatil = analysis.BuildingDatil; //赋值监测点详情
                                if(this.BuildingDatil.address == this.BuildingDatil.detailAddress){
                                    this.BuildingDatil.address = (this.BuildingDatil.detailAddress).replace(/\|/g, "<span style='margin:0 10px'>|</span>")
                                }else{
                                    this.BuildingDatil.address = (this.BuildingDatil.address +'|'+ this.BuildingDatil.detailAddress).replace(/\|/g, "<span style='margin:0 10px'>|</span>")
                                }
                            }
                            this.deviceNum = analysis.deviceNum; //赋值监测点详情
                            this.failCount = analysis.failCount; //赋值监测点详情
                            this.detailsArray = analysis.monitorByMultipleMatching; //赋值监测点详情
                            this.isScroll();
                            this.$store.state.listenerIsWarn = true;
                            this.$store.state.routerUrl=true;
                        }
                    })
                }
            },
            isScroll(){
              this.$nextTick(()=>{
                  if(document.getElementsByClassName('fixedScorll')[0].scrollHeight){
                    let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                    cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;

                    if(sHeight>cHeight){
                    document.getElementsByClassName('main_right')[0].style.marginRight=0;
                    document.getElementsByClassName('main_right')[0].style.marginRight=0;
                    }else {
                    document.getElementsByClassName('main_right')[0].style.marginRight='20px';
                    document.getElementsByClassName('main_right')[0].style.marginRight='20px';
                    }
                  }
              });
            },
            // 实时监测报警类型图表
            drawCylind() {
                this.myChart1 = echarts.init(document.getElementById('first'));
                let option = {
                    color: ['#198cff'],
                    title: {
                        text: '个',
                        //标题字体样式
                        textStyle: {
                            fontWeight:'normal',
                            color: '#282828',
                            fontSize: '13',
                            align: 'left',
                            lineHeight:'35',
                        }         
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        }
                    },
                    grid: {
                        left: '0%',
                        right: '0%',
                        top:'22%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type : 'category',
                        data : this.coordinateX,
                        // ['电气', '水压', '液位', '烟感', '可燃气', '灭火瓶'],
                        axisTick: {
                            show: false,//显示隐藏刻度
                            alignWithLabel: true,
                        },
                        //设置坐标轴字体颜色和宽度
                        axisLine: {
                            lineStyle: {
                                color: "#66b3ff",
                            }
                        },
                        axisLabel: {
                            color: '#282828',
                        }
                    },
                    yAxis: {
                        type : 'value',
                        minInterval: 1,
                        //设置坐标轴字体颜色和宽度
                        axisLine: {
                            lineStyle: {
                                color: "#66b3ff",
                            }
                        },
                        axisTick: {
                            show: false,//显示隐藏刻度
                        },
                        axisLabel: {
                            color: '#282828',
                            fontSize: '13',
                        },
                        //网格样式
                        splitLine: {
                            show: true,
                            lineStyle:{
                                color: ['#e0e0e0'],
                                width: 1,
                                type: 'solid'
                            }
                        },
                    },
                    series : [
                        {
                            name:'',
                            type:'bar',
                            // barWidth: '16%',
                            barWidth: 15, //柱图宽度
                            data:this.cydata,
                        }
                    ]
                };
                this.myChart1.setOption(option, true);
            },
            // 获取实时监控、实时监测报警类型数据
            getMonitor(){
              if(this.isAuth('common:interface')){
                let that = this;
                let params = {
                  customerId: sessionStorage.getItem('customerId'),
                  buildingId: sessionStorage.getItem('buildingId'),
                  pageType:1
                }
                ajaxFuncJson('/monitoring/realTimeMonitoring',params).then(res=>{
                  this.total = res.data.data.total;
                  this.realTimeTypeAlarm = res.data.data.realTimeTypeAlarm;
                  this.cydata=[];
                  this.coordinateX = [];
                    if(this.realTimeTypeAlarm.length == 0){
                        this.select1 = false;
                    }else{
                        this.select1 = true;
                        this.realTimeTypeAlarm.forEach((a,b)=>{
                                this.cydata.push(a.warnNum);
                                if(a.type ==1){
                                    a.type = '电气';
                                }else if(a.type ==2){
                                    a.type = '水压';
                                }else if(a.type ==3){
                                    a.type = '液位';
                                }else if(a.type ==4){
                                    a.type = '可燃气';
                                }else if(a.type ==5){
                                    a.type = '烟感';
                                }else if(a.type ==6){
                                    a.type = '灭火器';
                                }else if(a.type ==7){
                                    a.type = '水浸';
                                }else if(a.type ==8){
                                    a.type = '用传';
                                }
                                this.coordinateX.push(a.type);
                            })
                    }
                  let a = 1;
                  let arr = [];
                    arr[0]=res.data.data.realTimeStatus.normalData
                    arr[1]=res.data.data.realTimeStatus.alarmStatus
                    arr[2]=res.data.data.realTimeStatus.warnStatus
                    arr[3]=res.data.data.realTimeStatus.connectData
                  for(let i=0;i<arr.length;i++){
                    if(this.total == 0){
                      this.monitorList[i].percentage=0;
                      this.monitorList[i].value=0;
                    }else{
                      this.monitorList[i].value=arr[i];
                      this.monitorList[i].percentage=arr[i]/this.total*100;
                    }
                    if(arr[i] != 0){ //新增为0判断
                          a = 2;
                      }
                  }
                    if(a == 1){
                     this.select0 = false;
                    }else{
                        this.select0 = true;
                    }
                  this.drawCylind();
                });
              }
            }, 
            // 实时告警处理情况图表
            histogram() {
                const _dataList = this.dataList;
                this.myChart2 = echarts.init(document.getElementById('two'));
                let option = {
                    color:['#06d0b3','#00a0f5','#fc6900',],
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        y:'center',
                        left: '16%',
                        bottom: '23%',
                        icon:'rect',
                        itemWidth:10,
                        itemHeight:10,
                        formatter:function(name){
                            let target;
                            for(let i = 0;i <_dataList.length; i++){
                                if(_dataList[i].name === name){
                                    target = _dataList[i].value
                                }
                            }
                            let arr = ["{a|"+name+"}","{b|"+target+"}"]
                            return arr.join(" :  ")
                        },
                        textStyle:{
                            fontSize:13,
                            lineHeight:20,
                            rich: {
                                a: {
                                    color: '#282828',
                                },
                                b: {
                                    color: '#66b3ff',    
                                }
                            } 
                        },
                        // data:this.dataList.name,       
                    },
                    series: [
                        {
                            name:'实时报警处理情况',
                            type:'pie',
                            radius: ['30%', '40%'],
                            center: [220, 110],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: false
                                },
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data:this.dataList,
                        }
                    ]          
                };
                this.myChart2.setOption(option, true);
            },
            //获取实时告警处理情况数据
            getAlarmNotice(){
                if(this.isAuth('common:interface')) {
                    let that = this;
                    let params = {
                        customerId: sessionStorage.getItem('customerId'),
                        buildingId: sessionStorage.getItem('buildingId'),
                        pageType: 1
                    }
                    ajaxFuncJson('/alarmNoticeRecord/realTimeMonitoringDeal',params).then(res=>{
                        let b = 1;
                        for(let i = 0; i < res.data.data.dealArr.length; i++){
                            this.dataList[i].value=res.data.data.dealArr[i];
                            if(res.data.data.dealArr[i] != 0){ //新增为0判断
                                b = 2;
                            }
                            this.histogram();
                        }
                        if(b == 1){
                            this.select2 = false;
                        }else{
                            this.select2 = true;
                        }
                    });
                }
            },
            mapBtn() {
                this.$router.push({path:'/Home'})
            },
            //新建检测点跳转
            addMonitor() {
                this.$router.push({path:'/content/addMonitor'})
            },
            // tab组件切换
            handleClick(tab, event) {
            },
            initFont() {
              this.widthNum = $('.mains').outerWidth() - $('.main_right').outerWidth(true);
              let w = (this.widthNum - 20) / 364;
              let w1 = Math.round(w);
              this.widthCard = (this.widthNum - (w1*8) - 20) / w1;
              this.widthText = this.widthCard - 130;
            },
        },
        mounted() {
            let that = this;
           that.windowResize=function () {
                that.heightCard = $(document.body).height() -  $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.$nextTick(()=>{
                  that.heightBg =  $('.fixedScorll')[0].scrollHeight -$('.maindetails').outerHeight(true)-1;
                });
                that.widthNum = $('.mains').outerWidth(true) - $('.main_right').outerWidth(true);
                let w = (that.widthNum - 20) / 364;
                let w1 = Math.round(w);
                that.widthCard = (that.widthNum - (w1*8) - 20) / w1;
                that.widthText = that.widthCard - 130;
                that.isScroll();
            };
            that.windowResize();
            window.addEventListener('resize',that.windowResize);

            // this.drawCylind();
            this.histogram(); 
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        }
    }
</script>
<style scoped lang="scss">
    @import "@/assets/css/mixin.scss";
    .mains {
        display: flex;
    }
    .btns {
        li {
            float: left;
            @include wh(80px,30px);
            margin-top: 5px;
            text-align: center;
            line-height: 30px;
            font-size: $fontSizeTwo;
            outline: 1px solid #e0e0e0;
            outline-offset: -1px;
            &:nth-child(1):hover {
                color: #198cff;
                outline: 1px solid #198cff;
                cursor: pointer;
            }
            &:nth-child(2):hover {
                background-color: #3399ff;
            }
        }
        .btn_select1 {
            color: #fff;
            background-color: #198cff;
            outline: none;
        }
    }
    .main_left {
        flex: 1;
    }
    .el-main .maindetails{
        padding: 30px 40px;
        margin: 10px 0;
        height: 118px;
        margin-right: 1.05%;
        background-color: #fff;
        font-size: $fontSizeThree;
        line-height: 14px;
        color: #282828;
        &>div:first-child {
            width: 800px;
            @include flexible;
            .detailsName{
                height: 15px;
            }
            .detailsName>span:last-child{
                display: inline-block;
                width: 280px;
                vertical-align: middle;
                @include textOverflow
            }
            .detailsDevice{
                height: 15px;
                line-height: 15px;
                margin-left: 100px;
            }
        }
        .detailAddress{
            height: 15px;
            line-height: 15px;
            margin-top: 30px;
        }
    }
    .main_right {
        width: 360px;
        min-width: 360px;
        // max-height:821px;
        margin: 10px 20px 0 0;
        @include flexible;
        flex-direction:column;
        h2 {
            border-bottom: 1px solid #e5e5e5;
            background-color: #fafafa;
            color: $TxteAllcolor;
            text-align: center;
            line-height: 50px;
            font-weight: bold;
            font-size: $fontSizeThree;
        }
    }
    .monitor, .give_alarm, .hand_situa{
        flex-grow: 1;
        position: relative;
        height: 250px;
        margin-bottom: 10px;
        padding: 0 20px;
        background-color: #fff;
    }
    .hand_situa{
        margin-bottom: 0;
    }
    .monitor {
        padding: 0 0 0 20px;
    }
    .main_right h3 {
        margin-right: 20px;
        border-bottom: 1px solid #e0e0e0;
        color: $TxteAllcolor;
        line-height: 34px;
        font-size: $fontSizeThree;
    }
    .monitor li {
        height: 54px;
        @include flexible;
        @include alignItems(center);
        color:#282828!important;
        span {
            float: left;
            line-height: 56px;
            padding-right: 10px;
        }
    }
    .el-progress {
        float: left;
        width: 78%;
        @include flexible;
        @include alignItems(center);
    }
    .give_alarm {
        height: 250px;
    }
</style>



// WEBPACK FOOTER //
// src/page/Monitoring/index.vue